import React from "react";

const Numbers = () => (
  <section id="numbers" className="util__section numbers__root">
    <div className="util__container">
      <h2 className="numbers__title">La fidélité en un coup d'œil</h2>
      <div className="numbers__grid">
        <article className="numbers__item">
          <p className="numbers__stat">50%</p>
          <p className="numbers__description">
            Un client qui a la carte de fidélité dépense en moyenne 50% de plus.
            <span className="numbers__source">(Franceinfo)</span>
          </p>
        </article>
        <article className="numbers__item">
          <p className="numbers__stat">33%</p>
          <p className="numbers__description">
            Seulement 33% profitent des avantages des cartes de fidélité <b>physiques</b>.
            <span className="numbers__source">(Les Echos)</span>
          </p>
        </article>
      </div>
    </div>
  </section>
);

export default Numbers;
